import { Link, useNavigate } from "react-router-dom";
import { FiTrash2, FiPlus, FiMinus, FiArrowLeft } from "react-icons/fi";
import { useCart } from "../context/CartContext";
import "./Cart.css";

export default function Cart() {
  const { cart, dispatch, total, count } = useCart();
  const navigate = useNavigate();

  if (count === 0) return (
    <div className="cart-empty">
      <div className="empty-icon">🛒</div>
      <h2>Your cart is empty</h2>
      <p>Looks like you haven't added anything yet.</p>
      <Link to="/shop" className="btn-shop">Start Shopping</Link>
    </div>
  );

  return (
    <div className="cart-page">
      <Link to="/shop" className="back-link"><FiArrowLeft /> Continue Shopping</Link>
      <h1>Shopping Cart <span>({count} items)</span></h1>
      <div className="cart-layout">
        <div className="cart-items">
          {cart.map(item => (
            <div key={`${item.id}-${item.size}-${item.color}`} className="cart-item">
              <img src={item.image} alt={item.name} />
              <div className="item-info">
                <h3>{item.name}</h3>
                {item.size  && <p>Size: <strong>{item.size}</strong></p>}
                {item.color && <p>Color: <strong>{item.color}</strong></p>}
                <span className="item-price">Rs. {item.price.toLocaleString()}</span>
              </div>
              <div className="item-qty">
                <button onClick={() => item.qty === 1
                  ? dispatch({ type: "REMOVE", item })
                  : dispatch({ type: "UPDATE_QTY", item, qty: item.qty - 1 })}><FiMinus /></button>
                <span>{item.qty}</span>
                <button onClick={() => dispatch({ type: "UPDATE_QTY", item, qty: item.qty + 1 })}><FiPlus /></button>
              </div>
              <span className="item-total">Rs. {(item.price * item.qty).toLocaleString()}</span>
              <button className="remove-btn" onClick={() => dispatch({ type: "REMOVE", item })}><FiTrash2 /></button>
            </div>
          ))}
        </div>
        <div className="cart-summary">
          <h2>Order Summary</h2>
          <div className="summary-row"><span>Subtotal</span><span>Rs. {total.toLocaleString()}</span></div>
          <div className="summary-row"><span>Shipping</span><span className="free">FREE</span></div>
          <div className="summary-row total"><span>Total</span><span>Rs. {total.toLocaleString()}</span></div>
          <div className="promo-input">
            <input type="text" placeholder="Promo code" />
            <button>Apply</button>
          </div>
          <button className="checkout-btn" onClick={() => navigate("/checkout")}>Proceed to Checkout</button>
          <button className="clear-btn" onClick={() => dispatch({ type: "CLEAR" })}>Clear Cart</button>
          <div className="secure-note">🔒 Secure & Encrypted Checkout</div>
        </div>
      </div>
    </div>
  );
}
